import { connect } from 'react-redux';

import Button from './component';

const mapStateToProps = ({ i18n: { lan } }) => ({
	lan,
});

export default connect(mapStateToProps, () => ({}))(Button);



// WEBPACK FOOTER //
// ./src/components/atoms/Button/index.js